/*
 * @Author: Lina
 * @Date: 2020-07-27 13:47:21
 * @LastEditors: Lina
 * @LastEditTime: 2020-07-28 10:03:04
 */

import request from '../utils/request';
import { apiConfig } from './apiConfig';
import { getLocation } from './api'

// 酒店城市列表
function getCityList(data) {
  return request(`${apiConfig.selectApiHost(apiConfig.hotelApi)}/searchcore/h5/city`, data, { showLoading: true })
}


// 酒店列表
function getHotelList(data) {
  return request(`${apiConfig.selectApiHost(apiConfig.hotelApi)}/searchcore/h5/search`, data, { showLoading: false })
}

export default {

  rankHotelByCity: {
    getCityList: getCityList,
    getHotelList: getHotelList
  },
  getLocation: getLocation,
}